import StyledSwitch from "@plannel/components/ui/StyledSwitch";

// AI 카드 스케일에 맞춘 축소 스위치 — 공용 프리미티브는 건드리지 않고 sx 로만 조인다.
//   `&&` 로 StyledSwitch 기본 규칙보다 우선순위를 올린다.
const PAD = 2;
const RATIO = { root: 50 / 24, thumb: 26 / 20, press: 30 / 26 };   // StyledSwitch small 비율 유지

// height 하나로 나머지 치수를 파생시킨다(사이즈 변경이 숫자 1개로 끝난다).
//   px 문자열로 넘기는 이유: sx 의 padding·borderRadius 는 숫자를 테마 배율(8px·4px)로 환산한다.
const sizeSx = (h) => {
  const w = Math.round(h * RATIO.root);
  const th = h - PAD * 2;
  const tw = Math.round(th * RATIO.thumb);
  const tx = w - PAD * 2 - tw;
  const pw = Math.round(tw * RATIO.press);   // 눌렀을 때 폭. 고정 +4 는 작은 크기에서 과하게 튄다
  return {
    "&&": { width: `${w}px`, height: `${h}px` },
    "&& .MuiSwitch-switchBase": { padding: `${PAD}px` },
    // 첫 스위치만 비활성 시 MUI 기본색에 지는 삽입 순서 문제 — 우선순위를 올려 고정
    "&& .MuiSwitch-switchBase.Mui-checked": { transform: `translateX(${tx}px)`, color: "#fff" },
    "&& .MuiSwitch-thumb": { width: `${tw}px`, height: `${th}px`, borderRadius: `${th / 2}px` },
    "&& .MuiSwitch-track": { borderRadius: `${h / 2}px` },
    "&&:active .MuiSwitch-thumb": { width: `${pw}px` },
    "&&:active .MuiSwitch-switchBase.Mui-checked": { transform: `translateX(${tx - (pw - tw)}px)` },
  };
};

// accent — 카드마다 색이 다른 시나리오 카드·채널별 브랜드색에서 ON 트랙색을 맞춘다(미지정 시 앱 primary).
const accentSx = (accent) => ({
  "&& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": { backgroundColor: accent },
});

const AiStyledSwitch = ({ accent, height = 18, sx, ...rest }) => (
  <StyledSwitch size="small" {...rest}
    sx={{ ...sizeSx(height), ...(accent ? accentSx(accent) : null), ...sx }} />
);

export default AiStyledSwitch;
